module.exports = __webpack_public_path__ + "img/certification.74fac1dc.svg";